var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffHolidays(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0645 6.12903H4.12903C2.9532 6.12903 2 7.08223 2 8.25806V34.871C2 36.0468 2.9532 37 4.12903 37H36.0645C37.2403 37 38.1936 36.0468 38.1936 34.871V8.25806C38.1936 7.08223 37.2403 6.12903 36.0645 6.12903Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32263 4V9.32258",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7097 4V9.32258",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0968 4V9.32258",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4839 4V9.32258",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.871 4V9.32258",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.4516H38.1936",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55809 15.1774H6.15164C5.91647 15.1774 5.72583 15.3681 5.72583 15.6032V19.0097C5.72583 19.2449 5.91647 19.4355 6.15164 19.4355H9.55809C9.79326 19.4355 9.98389 19.2449 9.98389 19.0097V15.6032C9.98389 15.3681 9.79326 15.1774 9.55809 15.1774Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9452 15.1774H12.5387C12.3036 15.1774 12.1129 15.3681 12.1129 15.6032V19.0097C12.1129 19.2449 12.3036 19.4355 12.5387 19.4355H15.9452C16.1803 19.4355 16.371 19.2449 16.371 19.0097V15.6032C16.371 15.3681 16.1803 15.1774 15.9452 15.1774Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55809 21.5645H6.15164C5.91647 21.5645 5.72583 21.7552 5.72583 21.9903V25.3968C5.72583 25.6319 5.91647 25.8226 6.15164 25.8226H9.55809C9.79326 25.8226 9.98389 25.6319 9.98389 25.3968V21.9903C9.98389 21.7552 9.79326 21.5645 9.55809 21.5645Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9452 21.5645H12.5387C12.3036 21.5645 12.1129 21.7552 12.1129 21.9903V25.3968C12.1129 25.6319 12.3036 25.8226 12.5387 25.8226H15.9452C16.1803 25.8226 16.371 25.6319 16.371 25.3968V21.9903C16.371 21.7552 16.1803 21.5645 15.9452 21.5645Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55809 27.9516H6.15164C5.91647 27.9516 5.72583 28.1422 5.72583 28.3774V31.7839C5.72583 32.019 5.91647 32.2097 6.15164 32.2097H9.55809C9.79326 32.2097 9.98389 32.019 9.98389 31.7839V28.3774C9.98389 28.1422 9.79326 27.9516 9.55809 27.9516Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9452 27.9516H12.5387C12.3036 27.9516 12.1129 28.1422 12.1129 28.3774V31.7839C12.1129 32.019 12.3036 32.2097 12.5387 32.2097H15.9452C16.1803 32.2097 16.371 32.019 16.371 31.7839V28.3774C16.371 28.1422 16.1803 27.9516 15.9452 27.9516Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9355 15.7097H19.0323C18.7383 15.7097 18.5 15.948 18.5 16.2419V31.1451C18.5 31.4391 18.7383 31.6774 19.0323 31.6774H33.9355C34.2294 31.6774 34.4677 31.4391 34.4677 31.1451V16.2419C34.4677 15.948 34.2294 15.7097 33.9355 15.7097Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8226 22.5086C24.8871 17.8387 31.2742 18.9032 30.742 23.1613",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8226 22.7355C25.9517 21.5645 27.6526 21.7231 29.6775 22.7355C30.742 23.2678 30.742 23.2678 30.742 23.2678",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5484 22.0968L24.8871 29.0162",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7581 27.4194L29.1452 27.4194",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8226 27.4194L23.8226 29.0161",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0807 27.4194L28.0807 29.0161",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 30.6128C22.516 28.8618 30.5195 28.6726 34.4677 30.6128",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1451 27.4194L31.2742 25.2903",
    stroke: "#F4F4F9",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffHolidays);
export default __webpack_public_path__ + "static/media/StaffHolidays.de546ab6a9dffa1ab63322ae316404b8.svg";
export { ForwardRef as ReactComponent };